import { Skeleton, Stack, Typography } from "@mui/material";
import { type FC, useMemo } from "react";

import { isEmailChannel } from "../../../../../../channels/types";
import { usePreviewContext } from "../preview-context";
import { useEmailPreviewSource } from "../hooks/use-email-preview-source";
import { PreviewBodySubject } from "./preview-body-subject";

export const PreviewBodyHead: FC<{ isNewsletter: boolean }> = ({ isNewsletter }) => {
  const { channel, from } = useEmailPreviewSource();
  const {
    preview_info: { loading, data: previewInfo },
  } = usePreviewContext();

  const to = useMemo(() => {
    if (loading) return "";

    if (previewInfo?.classifyData.type === "channel")
      return previewInfo.classifyData.data.channel_name
        ? `#${previewInfo.classifyData.data.channel_name}`
        : "Not Set";

    return previewInfo?.selectedPreviewInfo?.recipient.display ?? "Sample Data";
  }, [loading, previewInfo]);

  return (
    <Stack
      direction="column"
      spacing={1}
      sx={{ py: 2, px: 4, borderWidth: 1, borderColor: "grey.200", borderStyle: "solid" }}
    >
      {loading && (
        <Skeleton
          variant="text"
          width="100%"
          height={20}
          data-testid="preview-body-head-loading-skeleton"
        />
      )}
      {!loading && (
        <>
          <Typography variant="body2">{`To: ${to}`}</Typography>
          {isEmailChannel(channel) && (
            <>
              <Typography variant="body2">{`From: ${from}`}</Typography>
              <PreviewBodySubject isNewsletter={isNewsletter} />
            </>
          )}
        </>
      )}
    </Stack>
  );
};
